import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=2bb7a84e&scoped=true&"
import script from "./Security.vue?vue&type=script&lang=js&"
export * from "./Security.vue?vue&type=script&lang=js&"
import style0 from "./Security.vue?vue&type=style&index=0&id=2bb7a84e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb7a84e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bb7a84e')) {
      api.createRecord('2bb7a84e', component.options)
    } else {
      api.reload('2bb7a84e', component.options)
    }
    module.hot.accept("./Security.vue?vue&type=template&id=2bb7a84e&scoped=true&", function () {
      api.rerender('2bb7a84e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Security.vue"
export default component.exports